export default function subFunction(data: string, cardnumber: number, total: number) {
  if (data === 'action') {
    for (let i = 0; i < total; i += 1) {
      const box2: HTMLBaseElement | null = document.querySelector(`#action${i}`);
      const box3: HTMLBaseElement | null = document.querySelector(`#edit${i}`);
      if (i === cardnumber) {
        if (box2 && box2.classList.contains('collapse')) {
          box2.classList.remove('collapse');
          box2.classList.add('show');
        } else if (box2) {
          box2.classList.add('collapse');
          box2.classList.remove('show');
        }
      } else if (i !== cardnumber && box2) {
        box2.classList.add('collapse');
        box2.classList.remove('show');
      }
      if (box3) {
        box3.classList.add('collapse');
        box3.classList.remove('show');
      }
    }
  } else if (data === 'edit') {
    for (let i = 0; i < total; i += 1) {
      const box2: HTMLBaseElement | null = document.querySelector(`#edit${i}`);
      const box3: HTMLBaseElement | null = document.querySelector(`#action${i}`);
      if (i === cardnumber) {
        if (box2 && box2.classList.contains('collapse')) {
          box2.classList.remove('collapse');
          box2.classList.add('show');
        } else if (box2) {
          box2.classList.add('collapse');
          box2.classList.remove('show');
        }
      } else if (i !== cardnumber && box2) {
        box2.classList.add('collapse');
        box2.classList.remove('show');
      }
      if (box3) {
        box3.classList.add('collapse');
        box3.classList.remove('show');
      }
    }
  } else if (data === 'hideAction') {
    for (let i = 0; i < total; i += 1) {
      const box2: HTMLBaseElement | null = document.querySelector(`#hideAction${i}`);
      const box3: HTMLBaseElement | null = document.querySelector(`#action${i}`);
      if (i === cardnumber) {
        if (box2 && box2.classList.contains('collapse')) {
          box2.classList.remove('collapse');
          box2.classList.add('show');
        } else if (box2) {
          box2.classList.add('collapse');
          box2.classList.remove('show');
        }
      } else if (i !== cardnumber && box2) {
        box2.classList.add('collapse');
        box2.classList.remove('show');
      }
      if (box3) {
        box3.classList.add('collapse');
        box3.classList.remove('show');
      }
    }
  }
}